import { Box, Modal, IconButton, Stack, styled } from "@mui/material";

const StyledModal = styled(Modal)({
  border: "none",
});

const StyledIconButton = styled(IconButton)({
  position: "absolute",
  right: 0,
  top: 0,
  backgroundColor: "#3F2A55",
  borderRadius: "0px 8px 8px 8px",
  color: "white",
  width: 64,
  height: 46,
  "&:hover": {
    backgroundColor: "#3F2A55",
  },
});

const CookieBox = styled(Box)({
  width: "48px",
  height: "48px",
  filter: "drop-shadow(0px 2px 4px rgba(23, 27, 30, 0.15))",
  display: "flex",
  alignItems: "center",
});

const ModalContent = styled(Stack)({
  position: "absolute",
  bottom: "8px",
  left: "8px",
  right: "8px",
  width: "calc(100% - 16px)",
  padding: "8px",
  borderRadius: "8px 16px 8px 8px",
  boxShadow: "0px 4px 16px 0px rgba(0, 0, 0, 0.12)",
  backgroundColor: "#FEFEFE",

  border: "none",

  gap: "16px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "space-between",

  "&:focus-visible": {
    outline: "none",
  },

  "@media (min-width: 400px)": {
    bottom: "16px",
    left: "16px",
    right: "16px",
    width: "calc(100% - 32px)",
    padding: "16px",
  },

  "@media (min-width: 1200px)": {
    flexDirection: "row",
    justifyContent: "space-around",
    paddingRight: "76px",
  },
  "@media (min-width: 1236px)": {
    maxWidth: "1236px",
    left: "50%",
    transform: "translateX(-50%)",
    gap: "32px",
    paddingRight: "84px",
  },
});

export { StyledModal, StyledIconButton, CookieBox, ModalContent };
